
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.257 4c.41 0 .743.333.743.743v14.514a.743.743 0 11-1.485 0V4.743c0-.41.332-.743.742-.743zm-6.599 2.512c.446-.07.892-.085 1.329-.047a.743.743 0 01-.128 1.48 4.01 4.01 0 00-.97.035c-1.556.246-2.842 1.43-3.14 2.927a.743.743 0 01-.779.597c-1.149-.08-2.265.55-2.735 1.556a.743.743 0 01-.94.379c-1.048-.404-2.242-.16-3.024.604a2.538 2.538 0 00-.574 2.845c.43.985 1.465 1.626 2.59 1.626h2.676a.743.743 0 010 1.486H6.288c-1.663 0-3.267-.943-3.953-2.518a4.024 4.024 0 01.899-4.503 4.35 4.35 0 013.978-1.114c.734-1.076 1.951-1.744 3.238-1.842.614-1.85 2.281-3.206 4.208-3.51zm2.585 2.784c.41 0 .743.332.743.743v9.218a.743.743 0 11-1.486 0v-9.218c0-.41.333-.743.743-.743zm-4.22 4.152c.41 0 .743.333.743.743v5.066a.743.743 0 11-1.485 0V14.19c0-.41.332-.743.742-.743z"}})])
          )
        }
      }
    